import { render, staticRenderFns } from "./FormAssistenza.vue?vue&type=template&id=e2e9a530&scoped=true"
import script from "./FormAssistenza.vue?vue&type=script&lang=js"
export * from "./FormAssistenza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e9a530",
  null
  
)

export default component.exports